let currentUid = null;

function setCurrentUid(event) {
  currentUid = event;
}

export { currentUid, setCurrentUid };
